import { useCallback } from "react";
import { useForm } from "react-hook-form";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

import SelectProvider from "components/custom-filters-list/filters/select-provider.component";
import Dialog from "components/dialog";

type BulkUpdateAssigneeModalProps = {
  isOpen: boolean;
  selectedCount: number;
  onClose: () => void;
  onSave: (assignee: number) => void;
  isLoading?: boolean;
};

export default function BulkUpdateAssigneeModal({
  isOpen,
  selectedCount,
  onClose,
  onSave,
  isLoading = false
}: BulkUpdateAssigneeModalProps) {
  const { control, handleSubmit, reset } = useForm<{
    assignee: { label: string; value: string } | null;
  }>({
    defaultValues: {
      assignee: null
    }
  });

  const onSubmit = useCallback(
    (data: { assignee: { label: string; value: string } | null }) => {
      if (data.assignee) {
        onSave(Number(data.assignee.value));
        reset();
      }
    },
    [onSave, reset]
  );

  const handleClose = useCallback(() => {
    reset();
    onClose();
  }, [reset, onClose]);

  return (
    <Dialog
      title={`Update Assignee for ${selectedCount} task${selectedCount !== 1 ? "s" : ""}`}
      open={isOpen}
      onClose={handleClose}
      maxWidth="sm"
    >
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3} sx={{ p: 2 }}>
          <SelectProvider
            name="assignee"
            control={control}
            label="Assignee"
            ignoreRegionsFilter
            ignoreClinicsFilter
          />
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button onClick={handleClose} disabled={isLoading}>
              Cancel
            </Button>
            <Button type="submit" variant="contained" disabled={isLoading}>
              Update
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Dialog>
  );
}
